import { render, staticRenderFns } from "./FieldText.vue?vue&type=template&id=5587e4dc&lang=pug&"
import script from "./FieldText.vue?vue&type=script&lang=ts&"
export * from "./FieldText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports